var map = {
	"./legal.da.i18n": [
		91118,
		655
	],
	"./legal.de.i18n": [
		81914,
		5307
	],
	"./legal.en.i18n": [
		56366,
		35491
	],
	"./legal.es.i18n": [
		50449,
		71112
	],
	"./legal.fi.i18n": [
		32196,
		71053
	],
	"./legal.fr.i18n": [
		75781,
		97424
	],
	"./legal.hi.i18n": [
		71970,
		99027
	],
	"./legal.id.i18n": [
		8784,
		79165
	],
	"./legal.it.i18n": [
		9504,
		61933
	],
	"./legal.ja.i18n": [
		22696,
		79777
	],
	"./legal.ko.i18n": [
		66563,
		14090
	],
	"./legal.nl.i18n": [
		96631,
		1106
	],
	"./legal.no.i18n": [
		54834,
		29747
	],
	"./legal.pl.i18n": [
		12349,
		1080
	],
	"./legal.pt.i18n": [
		33637,
		81088
	],
	"./legal.ru.i18n": [
		30164,
		74653
	],
	"./legal.sv.i18n": [
		81956,
		56937
	],
	"./legal.zh.i18n": [
		87439,
		94346
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 83802;
module.exports = webpackAsyncContext;